// プレビュー時にリンクを遷移させないようにする
// ダウンロードは AD/CP 双方を試し、ログイン中の方で取得する
$(() => {
    const LOGIN_REQUIRED_MESSAGE = "ダウンロードには管理画面へのログインが必要です。";
    const FORBIDDEN_MESSAGE = "この資料をダウンロードする権限がありません。";

    const parseFilename = (disposition) => {
        if (!disposition) return "document.pdf";
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utf8Match) {
            try {
                return decodeURIComponent(utf8Match[1]);
            } catch (_) {
                return utf8Match[1];
            }
        }
        const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
        return asciiMatch ? asciiMatch[1] : "document.pdf";
    };

    const showDownloadErrorModal = (message) => {
        $(".preview-download-modal-message").text(message);
        $(".mopop_preview_login").fadeIn();
    };

    const downloadFromBases = async ($link) => {
        const token = $link.data("preview-token");
        const preferred = $link.data("preferred");
        const adBase = $link.data("ad-base");
        const cpBase = $link.data("cp-base");
        const bases = preferred === "cp" ? [cpBase, adBase] : [adBase, cpBase];

        let sawForbidden = false;
        let sawUnauthorized = false;

        for (const base of bases) {
            if (!base) continue;
            try {
                const response = await fetch(`${base}document_dl/${token}`, {
                    credentials: "include",
                    redirect: "manual"
                });
                if (response.ok) {
                    const blob = await response.blob();
                    const filename = parseFilename(response.headers.get("Content-Disposition"));
                    const objectUrl = URL.createObjectURL(blob);
                    const anchor = document.createElement("a");
                    anchor.href = objectUrl;
                    anchor.download = filename;
                    document.body.appendChild(anchor);
                    anchor.click();
                    anchor.remove();
                    URL.revokeObjectURL(objectUrl);
                    return { ok: true };
                }
                if (response.status === 403) sawForbidden = true;
                if (response.status === 401) sawUnauthorized = true;
            } catch (e) {
                // 次のドメインを試す
            }
        }

        // ログイン済みだが権限なしを優先して案内する
        if (sawForbidden) {
            return { ok: false, message: FORBIDDEN_MESSAGE };
        }
        if (sawUnauthorized) {
            return { ok: false, message: LOGIN_REQUIRED_MESSAGE };
        }
        return { ok: false, message: LOGIN_REQUIRED_MESSAGE };
    };

    // PB他画面と同様のモーダル閉じる処理
    $(document).on("click", ".mopop_preview_login .modal-close", function (e) {
        e.preventDefault();
        $(".mopop_preview_login").fadeOut();
        return false;
    });

    $("a").on("click", async (e) => {
        const $target = $(e.target).closest("a");
        if ($target.hasClass("modal-close")) {
            return;
        }
        if ($target.data("lightbox") == "body_image") {
            // 資料イメージは素通り
            return;
        }
        if ($target.hasClass("preview-download-button")) {
            e.preventDefault();
            const result = await downloadFromBases($target);
            if (!result.ok) {
                showDownloadErrorModal(result.message);
            }
            return false;
        }
        // それ以外のリンクは潰す
        return false;
    });
});
